import { FC } from 'react'
import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

interface Props {
  title: string
}

export const EmbroideryPromoHeader: FC<Props> = ({ title }) => {
  return <EmbroideryPromoHeaderTitle>{title}</EmbroideryPromoHeaderTitle>
}

const EmbroideryPromoHeaderTitle = styled.span`
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  ${TypeStyle.css.headlineExtraExtraSmall};
  text-transform: capitalize;
`
